// extracted by mini-css-extract-plugin
module.exports = {"table-parent":"Failed_table-parent__E4pvq"};